import { ParameterType } from '@/study-search/enums';

import { FilterDefinition } from '../FilterDefinition';
import { FilterOptionInformation } from '@studyportals/search-filters';
import { SpecialProgrammesFilterOptionValue } from '@studyportals/search-filters';

class PhdSpecialProgrammesFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.SPECIAL_PROGRAMMES,
			[
				new FilterOptionInformation(
					'Executive Programmes',
					SpecialProgrammesFilterOptionValue.EXECUTIVE_PROGRAMMES,
					'',
					''
				),
				new FilterOptionInformation(
					'Joint Programmes',
					SpecialProgrammesFilterOptionValue.JOINT_PROGRAMMES,
					'joint-programmes',
					''
				),
				new FilterOptionInformation(
					'Erasmus Mundus Joint Doctorates',
					SpecialProgrammesFilterOptionValue.ERASMUS_MUNDUS,
					'erasmus-mundus',
					''
				)
			],
			[SpecialProgrammesFilterOptionValue.JOINT_PROGRAMMES, SpecialProgrammesFilterOptionValue.ERASMUS_MUNDUS]
		);
	}
}

export default new PhdSpecialProgrammesFilterDefinition();
